module.exports = __webpack_public_path__ + "static/media/ctc-fs-new-lumbar.b28baa01.png";